import { render, staticRenderFns } from "./ListaDeProdutosNaoParametrizados.vue?vue&type=template&id=aa10ef16"
import script from "./ListaDeProdutosNaoParametrizados.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDeProdutosNaoParametrizados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports